import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/database';
import "firebase/storage";
import * as Utils from './utilSvc';
import * as Const from './const';
import { isNullOrUndefined } from "util";
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from "constants";

export const writeUserToDb =(userId, userData) =>{
    if(!isNullOrUndefined(userId) && !isNullOrUndefined(userData)){
        firebase.firestore().collection("Users").doc(userId).set(userData);
    }
}

export const readUserFromDb =(userId) =>{
    if(!isNullOrUndefined(userId)){
        firebase.firestore().collection("Users").
                    doc(userId).get().then(function(doc) {
                        if (!doc.exists) {
                            
                            var userData = {
                                id: userId
                            };
                            writeUserToDb(userId,userData);                        
                        }
                        else{   
                            //                     
                        }
                    });
    }
}

export const createMeeting = (userId, meeting) => {
    setMeetingToDb(meeting);
    setUserToMeeting(userId, 'admin', meeting);
}

export const setMeetingToDb = (meeting) => {
    if(!isNullOrUndefined(meeting) && ('id' in meeting) && !isNullOrUndefined(meeting.id)){
        firebase.firestore().collection("Meetings").doc(meeting.id).set(meeting);
    }
}

export const setUserToMeeting = (userId, permit, meeting) => {
    if(!isNullOrUndefined(meeting) && ('id' in meeting)
    && !isNullOrUndefined(userId)){
        firebase.firestore().collection("Meetings").doc(meeting.id).collection("users").doc(userId).set({ 
            id: userId,
            permit: permit
        });
        firebase.firestore().collection("Users").doc(userId).collection("meetings").doc(meeting.id).set(meeting);
    }
}

export const removeUserFromMeeting = (userId, meeting) => {
    if(!isNullOrUndefined(meeting) && ('id' in meeting)
    && !isNullOrUndefined(userId)){
        firebase.firestore().collection("Meetings").doc(meeting.id).collection("users").doc(userId).delete();
        firebase.firestore().collection("Users").doc(userId).collection("meetings").doc(meeting.id).delete();
    }
}

export const createMeetingResearchSource = (meeting, source) => {
    if(!isNullOrUndefined(meeting) && ('id' in meeting)
    && !isNullOrUndefined(source) && ('link' in source) && (source['link'].trim()!='')){
        let sourceKey = Utils.getShaKey(source.link);
        firebase.firestore().collection("Meetings").doc(meeting.id).collection('sources').doc(sourceKey).set(source);
    }
}

export const saveMeetingResearchSource = (meeting,source) => {
    createMeetingResearchSource(meeting,source);
}

export const deleteMeetingResearchSource = (meeting, source) => {
    let sourceKey = Utils.getShaKey(source.link);
    if(!isNullOrUndefined(meeting) && ('id' in meeting)
    && !isNullOrUndefined(source) && ('link' in source) && (source['link'].trim()!='')){
        let sourceKey = Utils.getShaKey(source.link);
        firebase.firestore().collection("Meetings").doc(meeting.id).collection('sources').doc(sourceKey).delete();
    }
}

export const selectMeetingSource = (meeting, source, userId) => {
    let userKey = Utils.getShaKey(userId);
    if(!isNullOrUndefined(meeting) && ('id' in meeting)
    && !isNullOrUndefined(source) && ('link' in source) && (source['link'].trim()!='')
    && !isNullOrUndefined(userId) && userId.trim()!=''){
        firebase.database().ref('Meetings/'+ meeting.id +'/users/'+userKey).set({
            link: source.link,
            userId: userId,
            ts: Date.now()
        });
    }
}


export const writeYahooIncomeStatementToDb =(ticker, data, link) =>{
    if(!isNullOrUndefined(data) && Object.keys(data).length>0 
        && !isNullOrUndefined(ticker) && ticker.length>0){
        let docRef = firebase.firestore().collection("Data").doc("company").collection("incomeStatements").doc(ticker);
        docRef.get().then(function(doc) {
                let canAdd = true;
                if (doc.exists) {
                    let existingData = doc.data();
                    if('ts' in existingData && (Date.now() - existingData['ts'] < Const.updatePeriodForData['yahooIncomeStatement'])){
                        canAdd = false;
                    }
                }

                if(canAdd){
                    docRef.set({
                        data: data,
                        ts: Date.now(),
                        link: link
                    })
                }
            });
    }


}

export const readGoogleSearchDataFromDb = async (type, query, pageOffset) => {
    if(isNullOrUndefined(type) || (isNullOrUndefined(query))){
        return {}
    }
    let collectionRef = firebase.firestore().collection("Data").doc("google").collection(type);
    let docQuery = collectionRef.where('query','==',query).orderBy('ts').limit(1);
    if(!isNullOrUndefined(pageOffset)){
        docQuery = collectionRef.where('query','==',query).where('pageOffset','==',pageOffset).orderBy('ts','desc').limit(1);
    }
    let snapshot = await docQuery.get();
    let output = {};
    snapshot.forEach(doc => {
        if(doc.exists){
            let docData = doc.data();
            if(Math.abs(docData['ts']-Date.now())<9*30*24*60*60*1000){
                // 9 months
                if(!isNullOrUndefined(docData['data'])){
                    output = docData['data'];
                    // console.log(docData, output);
                }
            }
        }
    });

    return output;

}

export const writeGoogleSearchToDb = async (type, searchQueries, data, additionalFields) => {
    if(isNullOrUndefined(searchQueries) || isNullOrUndefined(data) || isNullOrUndefined(type))
        return;
    
    // type: search, news
    // searchQueries: query, pageOffset
    // additionalFields: company, category

    try{

        let objectData = {};    
        for(let key in searchQueries){
            objectData[key] = searchQueries[key];
        }
        if(!isNullOrUndefined(additionalFields)){
            for(let key in additionalFields){
                if(!(key in objectData))
                    objectData[key] = additionalFields[key];
            }   
        }
        objectData['data'] = data;
        let ts = Date.now();
        objectData['ts'] = ts;
        firebase.firestore().collection("Data").doc("google").collection(type).add(objectData);

    }
    catch(e){
        console.log(e);
    }
}

export const readWebscraperOutputFromDb = async (url) => {

    let collectionRef = firebase.firestore().collection("Data").doc("scrapers").collection("website");
    let docQuery = collectionRef.where('url','==',url).limit(1);
    let snapshot = await docQuery.get();
    let output = [];
    snapshot.forEach(doc => {
        if(doc.exists){
            let docData = doc.data();
            output = docData['data'];
        }
    });

    return output;
}


export const writeWebscraperOutputToDb = async (url, outputData) => {
    if(isNullOrUndefined(outputData) || isNullOrUndefined(url) || outputData == {} || outputData == [])
        return;

    let currentDocData = [];
    currentDocData = await readWebscraperOutputFromDb(url);
    if(currentDocData.length>0)
        return;

    //remove score from data
    let data = [];

    for(let i=0; !isNullOrUndefined(outputData) && i<outputData.length; i++){
        data.push(outputData[i].text)
    }

    let ts = Date.now();
    let objectData = {};   
    objectData['url'] = url;
    objectData['data'] = data;
    objectData['ts'] = ts;
    firebase.firestore().collection("Data").doc("scrapers").collection("website").add(objectData);
}

export const writeIconApiCallToDb = async (query, src, data) => {
    if(isNullOrUndefined(query) || isNullOrUndefined(src) || isNullOrUndefined(data)
    || query=="" || src ==""){
        return;
    }
    
    // console.log(src, data);
    firebase.firestore().collection("Data").doc("apicall-icons").collection(src).add({
        "query": query,
        "data": data
    });

}

export const getIconApiCallFromDb = async (query, src) => {
    if(isNullOrUndefined(query) || isNullOrUndefined(src)
    || query=="" || src ==""){
        return;
    }

    let collectionRef = firebase.firestore().collection("Data").doc("apicall-icons").collection(src);

    let docQuery = collectionRef.where("query","==",query);
    let snapshot = await docQuery.get();
    let output = [];
    // console.log(snapshot);
    snapshot.forEach(doc => {
        // console.log(doc);
        if(doc.exists){
            let docData = doc.data();
            output = docData['data'];
        }
    });

    // console.log(output, "in db");
    return output;

}

export const writeIconToDb = async (file, type, iconId) => {
    if(isNullOrUndefined(file) || isNullOrUndefined(iconId))
        return;
    try{

        
        if(type == 'iconfinder'){
            let ref1 = "Icons/icf/"+iconId+".svg";
            const storageRef = firebase.storage().ref();
            const iconRef = storageRef.child(ref1)

            iconRef.put(file).then((snapshot) => {
                console.log('Uploaded a blob or file!');
            });
        }
    }
    catch(e){

    }

}

export const getIconUrlFromDb = async (type, iconId) => {
    if(isNullOrUndefined(type) || isNullOrUndefined(iconId))
        return null;
    try{
        if(type == 'iconfinder'){
            let ref1 = "Icons/icf/"+iconId+".svg";
            var storage = firebase.storage();
            var pathReference = storage.ref(ref1);
            let url = await pathReference.getDownloadURL();

            return url;

        }
    }
    catch{

    }

    return null;
}